import IMask from 'imask';
import mask from '__jsLibs/mask';

export default () => {
	const inputs = document.querySelectorAll('input');

	const objMask = {};
	let i = 0;
	for (const input of inputs) {
		input.addEventListener('keyup', () => {
			input.classList.remove('is-error');
		});
		const obj = {};
		if (input.hasAttribute('data-mask')) {
			input.type = 'text';
			obj.mask = input.getAttribute('data-mask');
			if (input.getAttribute('data-mask') === 'percent') {
				if (!/%/.test(input.value) && input.value !== '') input.value += ' %';
			}
			objMask[i] = {
				type: obj.mask,
				mask: IMask(input, mask(obj))
			};
		}
		i++;
	}

	for (const key in objMask) {
		if (objMask.hasOwnProperty(key)) {
			const element = objMask[key];
			let timer;
			element.mask.on('accept', () => {
				if (element.type === 'percent') {
					clearTimeout(timer);
					timer = setTimeout(() => {
						if (!/%/.test(element.mask.value) && element.mask.value !== '') element.mask.value += ' %';
					}, 2000);
				}
			});
		}
	}

	if (Object.keys(objMask).length > 0) {
		const form = document.querySelector('form');
		let j = 0;
		if (form) {
			form.addEventListener('submit', e => {
				if (j === 0) e.preventDefault();

				for (const key in objMask) {
					if (objMask.hasOwnProperty(key)) {
						const element = objMask[key].mask;
						if (j === 0) element.destroy();
					}
				}
				for (const input of inputs) {
					if (input.hasAttribute('data-mask') && input.getAttribute('data-mask') !== 'text') {
						input.value = input.value.replace(/%/g, '').replace(/\$/g, '').replace(/\s/g, '').replace(',', '');
					}
				}
				j++;

				form.submit();
			});
		}
	}
};
